export default {

  headline: 'Portail de media SIEGENIA',
  search_info: 'Que recherchez-vous ?',
  back: 'Retour',
  no_results: 'Pas de résultats trouvés. Veuillez vérifier les termes de recherche.',
  service: {
    downloads: 'Téléchargements',
    videos: 'Vidéos',
    faq: 'FAQ'
  },
  service_search: {
    category_placeholder: "Filtre par catégorie"
  },
  service_download: {
    select_info: 'Veuillez sélectionner votre zone de recherche',
    select_productgroup: 'Sélectionner un groupe de produits',
    select_product: 'Sélectionner un produit',
    select_type: 'Sélectionner les médias',
    option_language: "Langue",
    types: {
      tec_info: 'Informations techniques',
      installation: 'Plan de montage/de pose',
      planning: 'Documents de planification',
      catalog: 'Brochures',
      order_forms: 'Formulaire de commande',
      maintenance: 'Entretien, manœuvre, maintenance',
      construction_drawings: 'Schémas de construction',
      software: 'Logiciel',
      certificate: 'Certificats et lignes directrices',
      press: 'Presse & documents commerciaux',
      videos: 'Vidéo',
      undefined: 'Autre',
      commercial: 'Spot commercial',
      product_video: 'Vidéo produit',
      operating: 'Utilisation',
      'function': 'Fonction',
      'assembly': 'Assemblage',
      'installation_video': 'Installation',
      'assembly_instructions': 'Instructions d\'arrêt',
      'brochure': 'Brochure',
      'tec_catalog': 'Catalogues techniques',
      'tec_sheet': 'Fiches techniques',
      'usage_charts': 'Diagrammes d\'application',
      'profile_sheet': 'Fiches de profil',
      'operations_manual': 'Instructions d\'utilisation et d\'entretien',
      hardware_info: 'Informations sur l\'ajustement',
      'installation_suggestion': 'Proposition d\'installation',
      'general': 'Généralement',
      'troubleshooting': 'Dépannage',
      "smarthome:general": 'Généralement',
      'smarthome:installation': 'Installation',
      'smarthome:troubleshooting': 'Dépannage',
      'smarthome:startup': 'Installation',
      'smarthome:operating': "Mode d'emploi",
      'order' : 'Commande',
    },
    filter_sorting: {
      filter: "Filtre",
      sorting: "Trier",
      asc: "Titre croissant (A-Z)",
      desc: "Titre décroissant (Z-A)",
      date_asc: "Date la plus ancienne en premier",
      date_desc: "Date de la dernière mise à jour en premier",
      relevance: "Pertinence",
      facet_headline: "Filtrer les résultats de la recherche",
      facet_filter_lang: "Langues",
      facet_filter_type_id: "Type",
      facet_filter_level_0: "Catégorie",
      filter_remove: "Réinitialisation du filtre",
      show_hide: "Afficher les filtres",
    },
    result: {
      count_media: "Médias",
      show_results: "Afficher",
      preview_type_catalog: "HTML",
      lang_not_available: "Actuellement indisponible dans votre langue",
      version_info: "Ce lien mène à la dernière version de la documentation. Si vous avez besoin d'une version plus ancienne, veuillez contacter votre conseiller clientèle SIEGENIA."
    }
  }

};
